import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/button';

export const ThemeToggle = ({ size = 'default', className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  
  return (
    <Button
      variant="ghost"
      size={size === 'sm' ? 'sm' : size === 'icon' ? 'icon' : 'default'}
      onClick={toggleTheme}
      className={className}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? (
        <>
          <Moon className="w-5 h-5" />
          {size === 'default' && <span className="ml-2">Dark Mode</span>}
        </>
      ) : (
        <>
          <Sun className="w-5 h-5" />
          {size === 'default' && <span className="ml-2">Light Mode</span>}
        </>
      )}
    </Button>
  );
};
